import { useState } from "react";
import { SystemLogsUIProvider } from "./SystemLogsUIContext";
import { ExceptionModal } from "./exception-modal/ExceptionModal";
import { SystemLogsCard } from "./SystemLogsCard";

export function SystemLogsPage() {
  const [id, setId] = useState();
  const [showExceptionModal, setShowExceptionModal] = useState();
  const closeExceptionModal = () => setShowExceptionModal(false);

  const systemLogsUIEvents = {
    openExceptionModal: (id) => {
      setId(id);
      setShowExceptionModal(true);
    }
  };

  return (
    <SystemLogsUIProvider systemLogsUIEvents={systemLogsUIEvents}>
      <ExceptionModal
        id={id}
        showExceptionModal={showExceptionModal}
        closeExceptionModal={closeExceptionModal}
      />
      <SystemLogsCard />
    </SystemLogsUIProvider>
 );
}